import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { ConfirmationWebScreen } from '@/features/bill-payment/screens/union-pay/ConfirmationWeb.screen';
import { ConfirmationNativeScreen } from '@/features/bill-payment/screens/union-pay/ConfirmationNative.screen';

export interface ConfirmationScreenProps {}

export const ConfirmationScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.Confirmation>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const {
    onLayout,
    onBack,
    wallet,
    calcFee,
    beneficiaryInformation,
    onChangeView,
    unionType,
    refresh,
    navigationNavigate,
    navigationScreen
  } = route.params;

  if (layout.isMobile) {
    return (
      <ConfirmationNativeScreen
        onBack={onBack}
        wallet={wallet}
        calcFee={calcFee}
        beneficiaryInformation={beneficiaryInformation}
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
  }
  return (
    <ConfirmationWebScreen
      onLayout={onLayout}
      onBack={onBack}
      wallet={wallet}
      calcFee={calcFee}
      beneficiaryInformation={beneficiaryInformation}
      onChangeView={onChangeView}
      unionType={unionType}
      refresh={refresh}
      navigationNavigate={navigationNavigate}
      navigationScreen={navigationScreen}
    />
  );
};
